
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/mobileapp",
      function () {
        return require("private-next-pages/settings/mobileapp.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/mobileapp"])
      });
    }
  